import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Permission } from '../types'
import AccessDenied from '../views/AccessDenied'

interface PermissionGuardProps {
  children: React.ReactNode
  requiredPermission?: Permission
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  requiredPermission,
}) => {
  const { user } = useAuth()

  // If no permission is required, allow access
  if (!requiredPermission) {
    return <>{children}</>
  }

  // Check if user has the required permission
  const hasPermission = user?.permissions?.includes(requiredPermission)

  if (!hasPermission) {
    return <AccessDenied />
  }

  return <>{children}</>
}

export default PermissionGuard
